export function initializeKeyboardShortcuts(service) {
  service.keyboardService.create(
    service.graph,
    service.clipboard,
    service.selection,
    service.paperScroller,
    service.commandManager,
    service.readOnly
  );
}
